import VueCookies from 'vue-cookies'
import Vue from 'vue'


Vue.use(VueCookies)